import { GridColDef } from '@mui/x-data-grid';

/**
 * Filters out columns that are hidden and returns an array of visible column fields.  Since columns may be hidden and only used in exports, this function is used to determine which columns should be displayed in the column visibility toggles (the 3 dot menu in each column header links to a manage columns visibility dialog and we don't want the user to be able to toggle hidden columns on).
 *
 * @param columns - An array of GridColDef objects representing the columns.
 * @param hiddenColumns - An array of strings representing the fields of hidden columns.
 * @returns An array of strings representing the fields of visible columns.
 */
export const hideColumnTogglesForHiddenColumns = (
  columns: GridColDef[],
  hiddenColumns: string[]
) => {
  return columns
    .filter((column) => !hiddenColumns.includes(column.field))
    .map((column) => column.field);
};
